import items from './services/items'
import types from './services/types'
import lists from './services/lists'
import selection from './services/selection'
import classics from './services/classics'
import initializer from './utils/initializer'
import blogUtils from './services/blogUtils'
import gcFixer from '../documentServicesDataFixer/fixers/styles/garbageCollectionFixer'
import appPart2StylesCollector from './utils/stylesCollectors/appPart2StylesCollector'
import appPartStylesCollector from './utils/stylesCollectors/appPartStylesCollector'

// custom style collectors registration
const collectors = [appPart2StylesCollector, appPartStylesCollector]
collectors.forEach(({componentsClasses, collect}) => {
    componentsClasses.forEach(componentClass => gcFixer.registerCustomStyleCollector(componentClass, collect))
})

export default {
    items,
    types,
    lists,
    selection,
    classics,
    initializer,
    blogUtils
}
